export const OnboardingNotEligible = () => null
